type Props = {
  disabled?: boolean;
  onPickFile: (file: File) => void;
};

export function BoardImageButton({ disabled, onPickFile }: Props) {
  function onChange(ev: React.ChangeEvent<HTMLInputElement>) {
    const file = ev.target.files?.[0];
    ev.target.value = "";
    if (file) onPickFile(file);
  }

  return (
    <label
      className={`wb-tool-icon-btn wb-tool-icon-btn--ghost${disabled ? " is-disabled" : ""}`}
      title="Изображение"
      aria-label="Добавить изображение"
    >
      <input
        type="file"
        accept="image/*"
        hidden
        disabled={disabled}
        onChange={onChange}
      />
      <svg
        className="wb-tool-icon-btn__svg"
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <rect x="3" y="5" width="18" height="14" rx="2" />
        <circle cx="9" cy="10" r="1.5" fill="currentColor" stroke="none" />
        <path d="m21 17-5-5-4 4-3-3-6 6" />
      </svg>
    </label>
  );
}
